<i18n>
  {
    "pt_BR": {
      "nav": {
        "reports": "Relatórios",
        "plan": "Pacotes",
        "logout": "Sair",
        "open": "Menu",
        "close": "Fechar",
        "campaign_create": "Criar mensagem",
        "campaign_show": "Detalhes",
        "invoice": "Faturas",
        "invoice_paypal": "Paypal",
        "admin": "Administração",
        "overview": "Visão Geral"
      },
      "message": "Criar Mensagem",
      "balance": {
        "text": "Saldo:",
        "without": "Sem saldo | Comprar"
      }
    }
  }
</i18n>

<template>
  <div class="main-view">
    <header class="header">
      <figure class="header_logo-container">
          <a class="header_logo-link" href="/">
            <img class="header_logo-image" src="~img/RDSMS_Logo.svg" title="Rapid Delivery SMS | Logo"/>
          </a>
      </figure>
      <!-- Menu -->
      <nav id="navLinks" class="header_nav-links" :class="{ 'active': open }">
        <router-link class="header_nav-link" :to="{ path: '/admin' }" v-t="'nav.admin'" v-if="root" />

        <router-link class="header_nav-link" :to="{ path: '/overview' }" v-t="'nav.overview'" />

        <router-link class="header_nav-link" :to="{ path: '/reports' }" v-t="'nav.reports'" />

        <router-link class="header_nav-link" :to="{ path: '/plan' }" v-t="'nav.plan'" />

        <!--<router-link class="header_nav-link" :to="{ path: '/invoice' }" v-t="'nav.invoice'" />-->
        <a href="https://chagbrasil.zendesk.com/hc/pt-br" class="header_nav-link" target="_blank">Suporte</a>

        <router-link class="header_nav-link" :to="{ path: '/auth/logout' }">
          <svg width="15" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Door Icon</title><desc>Created by Eryc Silva</desc><use xlink:href="#a" fill="#FFF"/><defs><path id="a" fill-rule="evenodd" d="M1 0a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12.741a1 1 0 0 0 1-1v-4.668a.87.87 0 1 0-1.741 0V17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v2.667a.871.871 0 0 0 1.741 0V1a1 1 0 0 0-1-1H1zm11.468 12.268a.682.682 0 0 1-1.089-.547v-.655c0-.102-.096-.178-.198-.178H7.095a.888.888 0 1 1 0-1.776h4.086c.102 0 .198-.075.198-.178V8.28c0-.56.64-.88 1.088-.547l1.971 1.466a1 1 0 0 1 0 1.605l-1.97 1.465z"/></defs></svg>
          {{  $t('nav.logout') }}
        </router-link>
      </nav>

      <nav class="header_nav-responsive">
        <button id="menuButton" class="header_nav-button" v-t="open ? 'nav.close' : 'nav.open'" @click.prevent="open = ! open"></button>
      </nav>
    </header>

    <section id="pageTitle" class="page-title">

      <div class="page-title--container">
        <h1 class="page-title--title" v-t="'nav.' + name"></h1>
      </div>
      <div class="page-title--container">
        <router-link class="page-title--saldo" :to="{ path: '/plan' }">
          <img src="~img/coins.svg" alt="">

          <span v-t="'balance.text'">Saldo: </span>
          <template v-if="hasBalance">
            {{ balance }} SMS
          </template>

          <span class="red" v-t="'balance.without'" v-else></span>
        </router-link>

        <router-link class="page-title--new-campaign" :to="{ path: '/campaign/new' }" v-t="'message'" />
      </div>

    </section>

    <router-view />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      open: false,
    }),

    computed: {
      ...mapGetters('auth', [
        'hasBalance', 'balance', 'root',
      ]),

      name () {
        return this.$route.name;
      },
    },
  };
</script>

<style scoped>
  .red {
    color: #f00;
  }

  .main-view {
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue